import { useEffect, useState } from "react";
import { api } from "../api/client";
import type { ApiList } from "../api/types";
import { isNightSlot } from "../utils/date";
import type { BookingsMap } from "./bookingTypes";
import { mapBooking, type RawBooking } from "./mapBooking";

/**
 * 15.08: занятость слотов для ПЕРЕОПРЕДЕЛЁННОЙ даты модалки брони. Календарь
 * шапки меняет дату, но dayBookings приезжали от исходного дня сетки — пикер
 * слотов показывал чужие статусы. Хук грузит карту выбранного дня той же
 * сборкой, что useBookings (день + ночной хвост date+1, ключ questId_time).
 * dateStr "" (нет переопределения) или загрузка не завершена → null — хост
 * остаётся на карте исходного дня.
 */
export function useOverrideDayBookings(dateStr: string): BookingsMap | null {
  const [map, setMap] = useState<{ date: string; map: BookingsMap } | null>(null);
  useEffect(() => {
    if (!dateStr) { setMap(null); return; }
    const ctrl = new AbortController();
    const next = new Date(`${dateStr}T12:00:00`);
    next.setDate(next.getDate() + 1);
    const nextStr = `${next.getFullYear()}-${String(next.getMonth() + 1).padStart(2, "0")}-${String(next.getDate()).padStart(2, "0")}`;
    Promise.all([
      api<ApiList<RawBooking>>(`/api/bookings?date=${dateStr}`, { signal: ctrl.signal }),
      api<ApiList<RawBooking>>(`/api/bookings?date=${nextStr}`, { signal: ctrl.signal }),
    ]).then(([dayRes, nightRes]) => {
      if (ctrl.signal.aborted) return;
      const m: BookingsMap = {};
      for (const raw of dayRes.results) {
        if (!isNightSlot(raw.time)) { const b = mapBooking(raw, false); m[`${b.questId}_${b.time}`] = b; }
      }
      for (const raw of nightRes.results) {
        if (isNightSlot(raw.time)) { const b = mapBooking(raw, true); m[`${b.questId}_${b.time}`] = b; }
      }
      setMap({ date: dateStr, map: m });
    }).catch(() => { /* обрыв сети — остаёмся на карте исходного дня */ });
    return () => ctrl.abort();
  }, [dateStr]);
  return map && map.date === dateStr ? map.map : null;
}
